import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=a8a745fa&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=a8a745fa&lang=less&scoped=true&"
import style1 from "./Comment.vue?vue&type=style&index=1&id=a8a745fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a745fa",
  null
  
)

export default component.exports